import {
	ILocaleStore,
	LocaleActions,
	LocaleActionTypes,
} from '../../../types/locale'

const initialState: ILocaleStore = {
	langData: {},
	langKey: '',
}

export default (state = initialState, action: LocaleActions): ILocaleStore => {
	switch (action.type) {
		case LocaleActionTypes.LOCALE_GET: {
			return action.payload
		}

		default:
			return state
	}
}
